// extracted by mini-css-extract-plugin
export default {"container":"productCard_container__AT1lk","iconContainer":"productCard_iconContainer__o56b1","viewMore":"productCard_viewMore__2Lmqr"};